<!-- vim: set filetype=html ts=2 sts=2 sw=2 expandtab: -->
<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
};
</script>

<style lang="scss">
@import '~@/scss/_customVariables.scss';
@import '~@/scss/theme.scss';
</style>



// WEBPACK FOOTER //
// App.vue?50ff9d8c